var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-code"},[_c('div',{staticClass:"nav"},[_c('router-link',{attrs:{"to":"/code/javascript"}},[_vm._v("javascript")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/codes"}},[_vm._v("code imgs")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }